export default __webpack_public_path__ + "static/media/Icon-menu_support.a859f144.svg";